export const getCertificateSignatories = (organizationName?: string) => {
    const organization = organizationName?.trim() || 'Organization';
    return [
        { name: organization, role: 'Organization' },
        { name: `${organization} Training Team`, role: 'Training Team' }
    ];
};
